/** Cache lifetimes for the integration catalog and per-restech config schemas.
 *
 * Both are deploy-time data, so they were cached aggressively — the schema with
 * `staleTime: Infinity`. That turned out to be actively misleading: the rows
 * query is fresh, so after a backend deploy the grid could report a config key
 * as missing while the cached schema had never heard of it, leaving the key
 * absent from the editor's "add property" list with no way to add it short of a
 * hard reload.
 *
 * A finite window costs one small request and removes that whole failure mode.
 * The catalog keeps the longer window: a new integration appearing late is
 * harmless, whereas a stale schema blocks editing.
 */
export const SCHEMA_STALE_MS = 5 * 60 * 1000;
export const CATALOG_STALE_MS = 60 * 60 * 1000;
